import React, { useState } from 'react';
import axios from 'axios';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import '../../styles/GlobalStyles.css'

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const REACT_APP_API_URL = process.env.REACT_APP_API_URL;  //changed URL

  const adminValidationSchema = Yup.object({
    email: Yup.string().email('Invalid email format').required('Email is required'),
    password: Yup.string().min(6, 'Password must be at least 6 characters').required('Password is required'),
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage('');

    try {
      await adminValidationSchema.validate({ email, password });

      const response = await axios.post(
        `${REACT_APP_API_URL}/api/auth/login-user`,
        { email, password },
        { withCredentials: true }
      );

      const accessToken = response.data?.accessToken;
      const refreshToken = response.data?.refreshToken;
      const role = response.data?.role;

      if (!accessToken) {
        throw new Error('No access token received.');
      }

      localStorage.setItem('token', accessToken);
      if (refreshToken) localStorage.setItem('refreshToken', refreshToken);
      if (role) localStorage.setItem('role', role);

      alert('Admin Login Successful!');
      navigate('/admin/dashboard');

    } catch (error) {
      console.error('Admin login error:', error);
      if (error.name === 'ValidationError') {
        setErrorMessage(error.message);
      } else if (error.response) {
        setErrorMessage(error.response.data?.message || 'Invalid email or password.');
      } else {
        setErrorMessage('Login failed. Please try again later.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container flex items-center justify-center min-h-screen">
      <div className="p-8 bg-white rounded-lg shadow-lg w-96">
        <h2 className="page-title">Admin Login</h2>

        {errorMessage && <div className="mb-4 text-sm text-red-500">{errorMessage}</div>}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="email" className="block text-sm font-medium text-gray-600">
              Email Address
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="profile-input profile-input:focus"
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="mb-6">
            <label htmlFor="password" className="block text-sm font-medium text-gray-600">
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="profile-input"
              placeholder="Enter your password"
              required
            />
          </div>

          <button
            type="submit"
            className="save-button"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
